import { createContext } from '../../utils';
const [DialogProvider, useDialogContext] = createContext('Dialog');
export { DialogProvider, useDialogContext };